import React, { PureComponent } from 'react';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';

import FuelEntity from './FuelEntity';

import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';

export default class Fuel extends PureComponent {

  state = {
    fuel: [],
    updating: false,
  }

  componentDidMount() {
    this.getFuelList();
  }

  getFuelList = async () => {
    let result = await api.fuel.fetchList();

    if (result.status === 200) {
      this.setState({fuel: result.data})
    }
  }

  updateAll = async () => {
    this.setState({updating: true})
    let result = await api.fuel.updateAll();

    if (result.status === 200) {
      this.setState({updating: false})
      return await this.getFuelList();
    }
  }

  render() {
    let { fuel, updating } = this.state;

    return (
      <div className='container'>
        <div className='row'>
          <div className='col-md-12 text-center m-v-1'>
            {
              updating ?
                <p>Updating...</p>
              :
                <RaisedButton
                  label='Update all'
                  primary
                  onClick={() => this.updateAll()}
                  style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                  buttonStyle={{ lineHeight: '25px', height: '25px' }}
                  labelStyle={{ fontSize: '11px' }}
                />
            }
          </div>
        </div>
        <h4 className='text-center color-common'>Fuel</h4>
        <Table selectable={false} className='fuel-table'>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow style={{borderBottom: '4px solid rgb(224, 224, 224)'}}>
              <TableHeaderColumn>
                Name
              </TableHeaderColumn>
              <TableHeaderColumn>
                IFO 180
              </TableHeaderColumn>
              <TableHeaderColumn>
                IFO 380
              </TableHeaderColumn>
              <TableHeaderColumn>
                MGO
              </TableHeaderColumn>
              <TableHeaderColumn>
                VLSFO
              </TableHeaderColumn>
              <TableHeaderColumn>
                ULSFO
              </TableHeaderColumn>
              <TableHeaderColumn>
                LSMGO
              </TableHeaderColumn>
              <TableHeaderColumn>
                Date
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>

          <TableBody displayRowCheckbox={false}>
            {
              fuel.length ?
                fuel.map((f, i) => {
                  return (
                    <FuelEntity
                      data={f}
                      ts={Date.now()}
                      key={`time-charter-region-${f._id}`}
                      getFuelList={this.getFuelList}
                      type='mpp'
                    />
                  )
                })
              : 'No data'
            }
          </TableBody>
        </Table>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/Fuel/index.js